export const Topography = () => {
  return (
    <svg
      className="fullscreen-svg"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 1440 1024"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M715.561 -29.6923C692.946 -37.2055 675.761 -20.2212 657.862 -10.1374C641.06 -0.672376 623.455 3.21711 615.934 23.7053C612.876 32.0341 612.168 41.2861 607.631 48.9109C604.283 54.5371 599.116 58.8081 594.052 62.9593C581.6 73.1669 569.148 83.3745 556.697 93.5841C548.595 100.227 540.301 107.095 535.22 116.258C530.14 125.42 528.957 137.537 535.107 146.02C545.83 160.811 568.846 155.726 586.096 161.742C608.591 169.588 619.62 196.078 641.105 206.375C639.648 217.865 639.607 232.295 649.839 237.724C658.919 242.541 669.652 236.738 679.143 232.792C690.158 228.212 702.878 226.183 713.972 230.568C725.066 234.953 733.535 247.124 730.833 258.744C728.67 268.038 720.085 276.749 723.494 285.662C724.987 289.568 728.522 292.29 730.792 295.807C744.226 316.628 712.53 346.905 743.114 358.063C766.018 366.418 793.797 358.876 812.743 379.492C831.16 399.532 822.05 434.168 806.465 453.22C790.686 472.511 761.794 461.295 747.622 483.766C745.173 487.649 743.668 492.066 741.221 495.949C732.638 509.58 714.796 513.822 702.784 524.551C685.95 539.586 682.832 564.96 668.723 582.575C659.596 593.97 646.52 601.335 634.955 610.24C623.39 619.143 612.547 631.036 611.344 645.582C610.362 657.449 616.415 668.515 616.033 680.202C615.601 693.426 610.898 703.254 612.716 717.27C613.282 721.637 614.209 726.212 617.133 729.505C620.874 733.719 626.896 734.823 632.015 737.182C653.341 747.017 658.292 778.234 679.941 787.334C691.556 792.215 706.477 789.872 715.441 798.724C722.958 806.15 722.662 818.918 717.531 828.154C712.398 837.39 703.525 843.858 694.78 849.793C645.578 883.183 591.503 909.381 534.804 927.296C531.124 928.459 527.094 929.581 523.493 928.193C516.946 925.671 515.935 917.062 512.592 910.892C506.905 900.392 493.406 896.671 481.49 897.426C469.574 898.181 458.064 902.306 446.148 903.065C404.861 905.688 373.189 869.632 341.026 843.61C314.391 822.059 283.403 805.909 250.481 796.417C243.7 794.461 236.299 792.437 232.082 786.776C226.235 778.93 229.039 767.97 228.426 758.204C227.4 741.869 214.849 726.92 198.94 723.081C190.694 721.093 182.071 721.864 173.6 721.432C137.522 719.587 98.4281 696.636 68.1076 716.278C60.3428 721.308 53.7183 728.994 44.5861 730.467C37.6511 731.584 30.7446 728.821 24.2642 726.112C-5.18588 713.805 -34.6339 701.497 -64.084 689.192"
        stroke="url(#paint0_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-width="3"
        stroke-miterlimit="10"
      />
      <path
        d="M1547.93 562.352C1527.48 563.752 1509.6 549.778 1490.42 542.547C1467.53 533.916 1442.35 534.914 1417.99 532.666C1357.56 527.093 1299.59 501.013 1238.92 502.212C1190.63 503.166 1144.2 521.489 1102.03 545.023C1081.48 556.486 1061.28 569.571 1046.51 587.886C1023.85 615.985 1016.35 655.622 1027.19 690.055C1038.02 724.491 1066.85 752.697 1101.52 762.766C1136.17 772.83 1173.2 765.402 1209.25 766.903C1245.3 768.405 1286.11 784.007 1296.31 818.615C1298.21 825.051 1298.95 831.921 1302.15 837.819C1307.31 847.343 1317.78 852.517 1327.7 856.887C1347.42 865.579 1368.83 873.591 1390.04 869.736C1409.89 866.125 1426.35 852.681 1444.78 844.446C1480.71 828.388 1525.3 833.788 1556.36 857.958"
        stroke="url(#paint1_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-width="3"
        stroke-miterlimit="10"
      />
      <path
        d="M1209.56 -34.3281C1191.62 -15.3048 1172.54 3.17684 1159.75 25.9761C1146.95 48.7753 1141.2 77.2433 1151.68 101.195C1162.16 125.141 1188.1 145.051 1183.6 170.798C1182.15 179.108 1177.48 186.611 1176.18 194.944C1173.88 209.579 1182.61 224.204 1194.51 233.023C1206.42 241.841 1221.07 245.964 1235.4 249.701C1257.8 255.539 1281.18 260.887 1303.89 256.433C1326.6 251.98 1348.49 235.06 1351.34 212.095C1352.68 201.356 1349.83 190.519 1350.21 179.705C1350.59 168.891 1355.77 156.77 1366.25 154.059C1374.93 151.811 1384.84 156.715 1392.82 152.62C1404.47 146.649 1401 129.073 1406.57 117.23C1413.79 101.881 1435.35 99.3628 1451.27 105.228C1467.19 111.094 1480.42 122.744 1496.21 128.945C1516.05 136.738 1539.38 135.056 1557.9 124.495"
        stroke="url(#paint2_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-width="3"
        stroke-miterlimit="10"
      />
      <path
        d="M1532.77 594.29C1498.16 579.075 1460.03 574.205 1422.52 569.5C1393.57 565.868 1364.62 562.237 1335.67 558.605C1300.92 554.247 1265.83 549.882 1230.99 553.384C1195.72 556.929 1161.31 568.634 1131.2 587.322C1113.02 598.607 1095.96 612.952 1086.25 632.022C1076.54 651.09 1075.46 675.581 1087.75 693.099C1095.03 703.483 1106.21 710.554 1117.88 715.509C1146.96 727.851 1179.44 728.364 1210.76 732.432C1242.09 736.502 1275.13 745.629 1295.35 769.901C1306.73 783.558 1313.17 801.092 1326.08 813.316C1353.51 839.311 1397.7 831.856 1433.61 820.064C1469.51 808.27 1509.69 794.002 1543.48 810.924"
        stroke="url(#paint3_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1380.82 651.864C1372.33 652.177 1363.52 653.524 1356.51 658.328C1349.5 663.131 1344.81 672.16 1347.28 680.296C1349.79 688.592 1358.62 693.374 1367.12 695.079C1375.62 696.783 1384.49 696.314 1392.87 698.524C1408.82 702.73 1422.09 716.348 1438.59 716.322C1467.34 716.277 1473.77 680.43 1452.51 664.924C1436.51 653.26 1399.24 651.189 1380.82 651.864Z"
        stroke="url(#paint4_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1421.88 620.866C1392.42 612.13 1365.34 609.922 1335.21 616.648C1305.01 623.388 1274.55 654.054 1293 686.17C1305.89 708.594 1331.54 714.567 1354.14 722.591C1372.11 728.97 1384.95 741.136 1401.69 749.079C1426.23 760.717 1456.51 756.771 1479.92 744.242C1499.3 733.868 1523.69 707.924 1516.55 683.828C1509.92 661.441 1481.78 645.112 1462.2 635.817C1449.23 629.662 1435.62 624.942 1421.88 620.866Z"
        stroke="url(#paint5_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1538.53 640.084C1494.27 619.88 1449.18 600.749 1401.79 589.719C1354.41 578.69 1304.28 576.038 1257.31 588.756C1239.13 593.68 1221.12 601.148 1207.49 614.162C1193.87 627.176 1185.28 646.544 1188.86 665.042C1192.41 683.436 1207.12 697.935 1223.55 706.929C1239.99 715.924 1258.4 720.515 1276.01 726.908C1293.62 733.301 1311.21 742.087 1322.53 757.022C1326.72 762.553 1329.94 768.804 1334.52 774.014C1346.76 787.927 1366.98 792.303 1385.43 790.589C1403.88 788.876 1421.39 782.014 1439.19 776.849C1474.65 766.556 1512.03 762.918 1548.81 766.176"
        stroke="url(#paint6_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1222.69 -21.8711C1204.71 -9.63658 1188.99 6.77349 1180.87 26.9452C1172.76 47.1149 1173.11 71.306 1184.87 89.5908C1191.63 100.099 1201.73 108.277 1207.63 119.292C1215.12 133.284 1214.92 150.019 1213.72 165.844C1213.03 175.058 1212.17 184.837 1216.38 193.063C1220.42 200.965 1228.44 205.979 1236.43 209.844C1247.9 215.395 1260.58 219.457 1273.25 218.086C1288.22 216.465 1302.08 206.78 1308.75 193.278C1313.78 183.088 1314.77 171.457 1317.56 160.439C1320.35 149.424 1325.83 138.018 1336.12 133.193C1342.35 130.269 1349.61 130.145 1355.86 127.268C1376.39 117.832 1375.27 86.239 1392.98 72.2149C1404.93 62.756 1422.31 64.0403 1436.57 69.3988C1450.84 74.7572 1463.65 83.5932 1478.11 88.3856C1501.78 96.2275 1529.08 92.1209 1549.39 77.6606"
        stroke="url(#paint7_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1270.37 -21.829C1258.84 -15.8112 1248.22 -8.08698 1238.93 1.01079C1225.36 14.3186 1214.19 33.2852 1219.19 51.6268C1223.17 66.2473 1236.51 76.8445 1240.75 91.392C1243.02 99.1608 1242.5 107.457 1243.89 115.429C1245.28 123.401 1249.42 131.8 1257.08 134.41C1260.16 135.461 1263.55 135.448 1266.72 134.702C1282.22 131.05 1288.62 112.82 1300.3 101.989C1310.2 92.8122 1323.93 89.0932 1335.05 81.4482C1351.71 69.9968 1361.37 50.1984 1363.92 30.1444C1366.46 10.0903 1362.59 -10.2823 1356.62 -29.5938"
        stroke="url(#paint8_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1392.04 -22.5977C1391.95 6.88488 1410.43 35.6208 1437.29 47.768C1452.78 54.7719 1470.08 56.4499 1487.04 57.5982C1505.4 58.842 1524.95 59.3066 1540.86 50.0587"
        stroke="url(#paint9_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1435.5 -25.4453C1434.83 -13.5821 1443.62 -3.13508 1453.56 3.37781C1467.35 12.4147 1484.02 16.4158 1500.5 16.7688C1516.98 17.1219 1533.36 13.9932 1549.28 9.69188"
        stroke="url(#paint10_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1299.1 -21.2316C1299.25 -10.4498 1290.02 -2.23058 1284.81 7.21008C1281.4 13.3801 1279.67 20.3251 1278.39 27.256C1276.64 36.7799 1276.46 48.4016 1284.3 54.0948C1289.57 57.9295 1297.09 57.5522 1302.87 54.5311C1308.65 51.51 1312.95 46.2672 1316.46 40.7647C1330.25 19.0916 1333.53 -8.95449 1325.1 -33.2227"
        stroke="url(#paint11_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M-36.0469 207.819C-28.4079 219.009 -17.4334 227.47 -6.17275 235.001C30.8838 259.787 73.7797 276.728 118.26 279.729C162.741 282.73 208.763 271.12 244.152 244.005C260.83 231.227 275.073 215.205 293.12 204.447C321.769 187.372 356.529 185.41 389.319 179.315C422.11 173.22 457.187 160.058 472.655 130.511C479.46 117.515 481.909 102.207 490.924 90.6358C503.724 74.2074 526.582 69.1696 541.69 54.8331C555.815 41.4299 561.543 21.5828 572.451 5.45068C585.186 -13.386 605.419 -27.0002 627.666 -31.6992"
        stroke="url(#paint12_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M-36.2383 182.723C-29.5448 192.42 -20.0453 199.817 -10.2841 206.419C21.83 228.139 59.0367 243.06 97.6617 246.046C136.287 249.033 176.117 239.288 207.405 216.747C212.498 213.078 217.432 209.15 222.214 204.973C231.679 196.705 240.392 187.854 250.577 180.97C254.649 178.231 258.873 175.849 263.26 173.776C281.729 165.007 303.133 161.807 324.089 158.412C327.922 157.792 331.741 157.161 335.537 156.481C352.359 153.462 369.82 148.678 384.477 140.256C395.5 133.913 404.904 125.497 411.214 114.431C417.689 103.095 420.448 89.6943 428.558 79.3082C440.074 64.5639 459.73 59.1182 472.586 45.8509C477.735 40.5392 481.547 34.2312 484.903 27.6006C489.379 18.7686 493.068 9.34218 498.177 0.934253C508.607 -16.2935 525.336 -29.1509 544.698 -34.3125"
        stroke="url(#paint13_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M-36.4297 157.633C-30.6797 165.836 -22.6552 172.173 -14.3974 177.842C12.7742 196.496 44.2917 209.394 77.0611 212.366C109.829 215.339 143.513 207.491 170.654 189.488C175.246 186.442 179.78 183.243 184.057 179.587C192.53 172.347 199.629 164.096 208.027 157.489C211.369 154.862 214.859 152.541 218.533 150.496C234.024 141.795 253.025 138.342 271.596 135.319C274.992 134.767 278.381 134.219 281.749 133.643C296.694 131.083 312.175 127.285 325.365 120.238C335.256 114.938 343.798 107.78 349.767 98.3478C355.911 88.6738 358.978 77.1778 366.185 67.9786C376.417 54.9183 392.872 49.0628 403.475 36.8688C407.722 31.9912 410.834 26.3021 413.508 20.3492C417.075 12.4343 419.91 4.01621 423.894 -3.5842C432.022 -19.203 445.247 -31.3056 461.722 -36.9258"
        stroke="url(#paint14_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M-36.6211 132.538C-31.8145 139.247 -25.2651 144.523 -18.5108 149.258C3.71831 164.846 29.5467 175.722 56.4606 178.682C83.3725 181.642 110.974 175.746 133.903 162.227C138.002 159.811 142.131 157.333 145.9 154.201C153.379 147.99 158.875 140.351 165.48 134.009C168.093 131.499 170.85 129.241 173.806 127.214C186.345 118.619 202.92 114.874 219.103 112.224C222.063 111.739 225.019 111.278 227.961 110.804C241.031 108.702 254.53 105.889 266.253 100.219C275.014 95.9619 282.69 90.0597 288.32 82.2604C294.133 74.2481 297.511 64.6573 303.813 56.6451C312.76 45.2708 326.011 39.0054 334.365 27.8808C337.708 23.4353 340.121 18.363 342.115 13.0918C344.775 6.094 346.77 -1.30961 349.614 -8.10656C355.47 -22.1042 365.158 -33.4643 378.748 -39.543"
        stroke="url(#paint15_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M-36.8154 107.445C-32.9523 112.66 -27.8779 116.874 -22.625 120.68C-5.33845 133.203 14.8008 142.055 35.8592 145.003C56.9155 147.949 78.5298 144.104 97.1535 134.97C100.775 133.195 104.48 131.428 107.745 128.818C114.231 123.636 118.125 116.618 122.933 110.532C124.822 108.141 126.841 105.936 129.081 103.937C138.647 95.4098 152.813 91.4128 166.61 89.1343C169.132 88.7184 171.658 88.341 174.174 87.9697C185.368 86.3242 196.888 84.4982 207.14 80.207C214.769 76.9931 221.58 72.3489 226.872 66.1809C232.354 59.8283 236.043 52.1447 241.44 45.3193C249.103 35.6291 259.152 28.9559 265.253 18.9005C267.694 14.8873 269.406 10.4358 270.719 5.84225C272.47 -0.238486 273.614 -6.63574 275.331 -12.6211C278.886 -25.0139 285.068 -35.6131 295.771 -42.1523"
        stroke="url(#paint16_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M-37.0078 82.3534C-34.0882 86.0745 -30.4909 89.2255 -26.7393 92.1005C-14.3973 101.559 0.0548444 108.387 15.2557 111.321C30.4545 114.254 46.2011 112.654 60.3996 107.711C63.5647 106.609 66.8273 105.52 69.5846 103.434C75.079 99.2809 77.3798 92.8897 80.3826 87.0545C81.5493 84.7882 82.8235 82.6273 84.3512 80.6613C90.9352 72.1905 102.705 67.952 114.116 66.0448C116.202 65.6958 118.295 65.4037 120.387 65.1359C129.706 63.9469 139.244 63.1089 148.03 60.1934C154.528 58.0224 160.473 54.6341 165.426 50.1014C170.575 45.4105 174.574 39.6321 179.068 33.9936C185.447 25.9874 192.295 18.9064 196.144 9.92229C197.682 6.34121 198.694 2.50854 199.325 -1.40731C200.169 -6.57097 200.453 -11.9639 201.05 -17.1357C202.294 -27.9256 204.98 -37.7639 212.795 -44.7617"
        stroke="url(#paint17_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M-37.2002 57.2615C-22.2266 74.1464 1.23809 83.0899 23.6518 80.4543C26.3746 80.1338 29.1786 79.6144 31.4308 78.0521C37.6576 73.7304 36.6634 64.3588 39.6277 57.3833C43.2067 48.9591 52.6007 44.4873 61.6254 42.9534C70.6481 41.4196 79.965 42.0648 88.9208 40.1799C111.02 35.5295 128.282 13.9213 127.935 -8.65876C127.734 -21.8448 122.553 -36.3741 129.824 -47.375"
        stroke="url(#paint18_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M-73.4176 613.245C-53.9377 638.101 -31.1263 664.914 0.235023 668.627C25.9011 671.666 50.7922 658.123 76.6328 657.581C101.459 657.062 124.909 668.505 149.484 672.064C183.791 677.029 219.178 666.107 247.934 646.751C297.27 613.543 328.325 554.771 327.962 495.3C327.832 474.135 324.015 452.739 328.029 431.959C331.038 416.381 338.301 401.998 343.321 386.947C352.717 358.777 354.115 327.988 347.312 299.084C345.419 291.039 342.745 282.854 337.135 276.786C326.866 265.677 309.206 264.592 294.868 269.416C280.529 274.241 268.39 283.824 255.616 291.926C204.131 324.579 140.81 333.61 79.8791 331.506C60.9632 330.853 41.8506 329.159 23.9615 322.98C-0.148447 314.652 -20.73 298.672 -40.8247 282.962C-49.4923 276.185 -60.2903 273.653 -71.0985 275.714C-81.9066 277.776 -91.467 284.019 -99.9013 291.086C-132.736 318.602 -152.382 361.204 -151.994 404.041C-151.836 421.63 -148.494 439.038 -144.372 456.138C-131.202 510.781 -108.088 569.004 -73.4176 613.245Z"
        stroke="url(#paint19_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M43.0935 355.43C23.6643 349.567 6.41835 338.225 -10.3995 326.764C-17.6063 321.852 -26.3876 320.072 -35.1912 321.77C-44.015 323.475 -51.9015 328.324 -58.9257 333.814C-86.5295 355.258 -103.94 388.409 -104.908 423.035C-105.261 437.166 -103.029 451.345 -99.9509 465.523C-88.8648 508.325 -70.9939 554.216 -43.6316 589.106C-28.1487 608.845 -9.8355 629.77 15.0129 633.006C35.351 635.654 55.186 625.622 75.7046 625.052C95.9819 624.421 115.017 632.237 134.832 633.957C162.434 636.398 190.727 626.596 214.291 611.004C253.375 584.977 279.11 540.305 280.494 494.015C280.977 477.55 278.564 460.923 281.908 444.773C284.475 432.565 290.131 421.268 294.017 409.488C301.331 387.265 302.21 363.165 296.626 340.601C295.072 334.323 292.911 327.951 288.524 323.174C280.51 314.448 266.888 313.271 255.706 316.564C244.547 319.873 234.993 326.784 224.927 332.619C184.49 356.199 134.714 362.574 86.9328 361.31C72.085 360.919 57.154 359.673 43.0935 355.43Z"
        stroke="url(#paint20_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M62.2275 387.886C47.4406 384.508 33.589 377.78 20.0296 370.569C14.2918 367.518 7.51917 366.495 0.720191 367.832C-6.1214 369.179 -12.3198 372.655 -17.9481 376.548C-40.2705 391.995 -55.5849 415.614 -57.8188 442.035C-58.7217 452.705 -57.5611 463.657 -55.5261 474.916C-46.5277 505.875 -33.8976 539.436 -13.8435 564.974C-2.35771 579.597 11.4573 594.635 29.7929 597.393C44.801 599.651 59.5859 593.187 74.7786 592.529C90.511 591.847 105.127 595.974 120.18 595.859C141.078 595.778 162.319 587.157 180.651 575.263C209.549 556.513 229.897 525.846 233.03 492.734C234.125 480.968 233.072 469.099 235.791 457.592C237.881 448.746 241.967 440.543 244.719 432.032C249.953 415.758 250.31 398.345 245.944 382.126C244.731 377.616 243.079 373.053 239.918 369.569C234.158 363.226 224.569 361.936 216.549 363.715C208.565 365.487 201.587 369.721 194.245 373.314C164.809 387.722 128.625 391.542 93.9906 391.114C83.2108 390.986 72.4351 390.217 62.2275 387.886Z"
        stroke="url(#paint21_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M81.3581 420.35C71.1363 419.532 60.7968 417.313 50.4553 414.385C46.2046 413.182 41.4224 412.928 36.626 413.902C31.7687 414.892 27.2442 416.976 23.026 419.291C5.92814 428.677 -7.15041 442.822 -10.7335 461.042C-12.1518 468.249 -12.0949 475.975 -11.1048 484.314C-4.19222 503.433 3.19516 524.664 15.941 540.847C23.4318 550.352 32.7467 559.503 44.5693 561.783C54.2474 563.652 63.9802 560.7 73.8469 560.01C85.0325 559.227 95.2279 559.685 105.525 557.762C119.711 555.114 133.873 547.668 147.006 539.526C165.654 527.965 180.681 511.391 185.56 491.458C187.271 484.391 187.612 477.286 189.669 470.416C191.31 464.936 193.796 459.823 195.413 454.582C198.566 444.255 198.404 433.534 195.257 423.653C194.384 420.908 193.244 418.159 191.308 415.967C187.802 412.007 182.255 410.619 177.388 410.873C172.585 411.122 168.191 412.68 163.559 414.018C145.18 419.317 122.529 420.518 101.045 420.926C94.3311 421.062 87.66 420.853 81.3581 420.35Z"
        stroke="url(#paint22_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M33.3203 493.706C38.1472 500.984 40.2918 509.883 45.7293 516.714C52.084 524.7 62.8231 528.953 72.9232 527.486C88.5339 525.217 99.48 511.266 113.368 503.784C121.699 499.296 131.47 496.93 138.097 490.176C164.209 463.558 124.18 442.993 100.49 452.803C77.3443 462.389 33.6612 458.709 33.3203 493.706Z"
        stroke="url(#paint23_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M586.723 220.525C597.3 232.811 603.466 248.277 613.126 261.295C622.785 274.313 638.254 285.332 654.161 282.209C658.578 281.343 662.93 279.407 667.398 279.961C675.067 280.911 679.939 288.698 682.221 296.081C687.872 314.358 684.585 334.051 685.739 353.145C686.894 372.24 694.943 393.592 713.047 399.772C720.954 402.473 730.216 402.039 736.743 407.255C748.695 416.809 742.069 436.575 731.386 447.531C716.204 463.102 695.492 472.027 678.861 486.041C655.506 505.723 641.47 534.275 620.227 556.222C596.013 581.237 562.388 596.916 527.661 599.383C492.933 601.851 457.429 591.081 429.924 569.739C412.344 556.098 398.208 538.566 384.991 520.665C380.276 514.278 375.528 507.531 374.137 499.716C372.909 492.819 374.423 485.755 376.093 478.952C381.143 458.384 387.696 438.186 395.684 418.572C400.217 407.444 405.271 396.28 406.517 384.328C407.815 371.876 404.895 359.427 402.43 347.154C395.674 313.51 392.921 276.025 411.698 247.303C444.06 197.807 543.819 170.691 586.723 220.525Z"
        stroke="url(#paint24_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M449.977 291.759C471.563 253.7 542.773 233.327 576.155 266.756C584.336 274.949 589.534 285.42 597.025 294.34C604.582 303.273 615.944 310.965 627.471 309.38C630.691 308.938 633.866 307.755 637.086 308.335C643.051 309.411 647.014 315.368 649.148 321.063C653.496 332.658 653.311 345.299 653.374 357.898C653.391 360.662 653.427 363.376 653.514 366.042C654.028 381.838 657.453 397.213 667.457 402.675C671.882 405.089 676.902 405.656 680.731 409.689C687.716 417.05 683.468 430.171 676.032 438.009C665.459 449.154 651.311 455.943 639.943 466.148C632.413 472.905 626.29 480.984 620.402 489.29C613.802 498.605 607.486 508.223 599.804 516.6C583.234 534.668 560.246 546.239 536.199 549.215C511.665 552.253 485.585 546.241 465.407 530.977C452.241 521.07 442.16 507.614 433.287 494.024C430.122 489.203 426.991 484.147 426.125 478.379C425.36 473.288 426.443 468.088 427.63 463.062C429.069 456.974 430.67 450.925 432.396 444.924C434.979 435.942 437.838 427.071 440.991 418.342C443.973 410.079 447.258 401.794 447.975 392.985C448.721 383.808 446.627 374.631 444.828 365.572C439.891 340.731 437.696 313.41 449.977 291.759Z"
        stroke="url(#paint25_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M488.254 336.213C498.991 309.484 541.66 295.971 565.585 312.984C571.355 317.087 575.575 322.587 580.922 327.379C586.357 332.255 593.641 336.603 600.779 336.544C602.804 336.528 604.8 336.128 606.77 336.702C611.039 337.944 614.085 342.032 616.071 346.036C620.121 354.192 621.147 363.482 621.275 372.854C621.306 374.964 621.31 376.989 621.285 378.935C621.123 391.435 619.802 400.697 621.864 405.571C622.742 407.648 624.221 408.705 624.714 412.114C627.811 416.18 624.862 423.76 620.673 428.477C614.71 435.195 607.127 439.85 601.02 446.245C596.977 450.473 593.672 455.379 590.498 460.387C586.936 466.015 583.519 471.808 579.38 476.965C570.454 488.084 558.068 495.629 544.734 499.036C530.346 502.71 513.764 501.349 500.884 492.202C492.154 486.002 486.136 476.634 481.577 467.368C479.974 464.11 478.45 460.748 478.107 457.027C477.805 453.744 478.456 450.408 479.164 447.156C480.018 443.22 480.958 439.302 481.907 435.406C483.33 429.573 484.778 423.797 486.292 418.095C487.726 412.698 489.238 407.291 489.427 401.622C489.623 395.718 488.353 389.814 487.217 383.969C484.107 367.95 482.421 350.731 488.254 336.213Z"
        stroke="url(#paint26_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M526.53 380.662C527.188 395.853 532.893 410.761 531.418 425.893C530.935 430.844 529.685 435.746 529.868 440.717C530.051 445.687 532.027 450.991 536.363 453.43C541.887 456.538 549.21 453.724 553.268 448.857C557.326 443.987 558.945 437.602 560.594 431.483C562.244 425.364 564.202 419.003 568.7 414.539C578.666 404.65 589.703 404.453 589.18 387.81C588.892 378.655 584.055 369.951 576.456 365.072C560.606 354.892 525.492 356.641 526.53 380.662Z"
        stroke="url(#paint27_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M328.526 638.96C316.233 656.212 305.356 674.472 296.037 693.498C292.385 700.952 288.905 708.814 288.848 717.115C288.714 736.576 306.514 750.757 322.563 761.766C349.725 780.399 376.888 799.033 404.05 817.667C418.38 827.497 433.483 837.628 450.756 839.561C468.578 841.556 487.709 834.682 504.001 842.175C510.9 845.348 516.481 850.818 523.112 854.521C546.027 867.315 574.791 856.373 597.055 842.479C606.264 836.733 616.114 828.82 616.317 817.967C616.536 806.222 605.197 797.589 594.186 793.494C583.175 789.4 570.847 787.442 562.064 779.641C545.438 764.876 549.874 738.55 546.528 716.569C542.21 688.208 522.781 663.936 499.359 647.372C475.067 630.191 440.495 610.183 412.293 600.112C378.065 587.892 347.292 612.624 328.526 638.96Z"
        stroke="url(#paint28_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M361.606 677.202C355.83 687.341 350.141 697.518 346.022 708.15C344.407 712.315 342.81 716.665 343.234 721.173C344.302 732.556 355.806 740.087 365.924 746.156C382.945 756.398 399.838 767.113 416.485 778.244C425.268 784.115 434.35 790.346 444.468 792.399C454.544 794.443 465.275 791.947 474.793 796.348C478.845 798.22 482.269 801.158 486.232 803.135C499.927 809.96 516.735 803.983 529.814 795.812C535.848 792.038 541.815 786.992 542.693 780.358C543.659 773.058 538.477 767.129 533.05 763.44C527.647 759.768 521.243 757.132 516.339 751.606C507.158 741.258 507.666 725.256 503.803 712.055C501.159 703.025 496.154 694.909 489.874 688.102C484.215 681.966 477.191 676.533 469.532 672.12C452.943 662.533 430.43 652.232 412.06 648.144C390.229 643.28 372.076 658.824 361.606 677.202Z"
        stroke="url(#paint29_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M394.683 715.451C394.508 718.941 395.287 722.633 397.617 725.239C400.508 728.475 405.091 729.424 409.283 730.55C419.795 733.375 429.706 738.413 438.183 745.242C440.551 747.149 442.844 749.217 445.589 750.523C450.941 753.072 457.558 752.303 462.575 749.148C482.047 736.899 467.765 707.283 450.834 700.299C433.61 693.192 396.012 689.024 394.683 715.451Z"
        stroke="url(#paint30_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M-33.0762 745.453C-11.7885 772.326 28.8694 771.29 62.6107 765.219C96.352 759.146 134.186 751.298 162.518 770.602C184.343 785.472 194.277 812.844 214.207 830.174C235.16 848.389 264.403 853.328 288.401 867.289C327.237 889.883 355.233 936.963 400.147 938.091C412.956 938.414 425.679 934.674 438.454 935.674C458.812 937.269 476.139 950.453 495.118 957.989C537.444 974.796 585.978 962.57 626.768 942.313C667.558 922.056 704.401 894.053 746.589 876.896C788.777 859.739 840.052 855.101 877.587 880.893C938.383 922.671 932.369 1017.09 980.134 1073.3"
        stroke="url(#paint31_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M552.319 1024.81C595.739 995.335 640.653 968.058 686.83 943.121C713.521 928.707 741.202 914.884 771.165 910.148C801.128 905.413 834.123 911 856.496 931.487C874.024 947.535 883.13 970.548 891.678 992.722C896.067 1004.11 900.457 1015.49 904.846 1026.88"
        stroke="url(#paint32_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M636.36 1026.98C655.272 1013.27 674.184 999.557 693.098 985.845C707.598 975.331 722.288 964.712 738.913 958.045C755.538 951.377 774.568 948.969 791.353 955.22C818.888 965.475 833.206 995.099 844.846 1022.08"
        stroke="url(#paint33_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M-38.583 803.628C-11.9856 815.664 18.8502 809.275 47.4948 803.645C76.1414 798.012 107.982 793.896 132.706 809.417C141.323 814.824 148.416 822.281 155.794 829.284C171.033 843.751 187.78 856.523 204.49 869.263C214.96 877.245 225.545 885.295 237.544 890.713C244.909 894.038 252.714 896.325 260.032 899.75C290.966 914.224 310.409 947.48 342.111 960.184C372.627 972.412 409.856 963.562 437.727 980.992C457.124 993.123 467.553 1015.55 473.544 1037.63"
        stroke="url(#paint34_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M-41.6074 833.918C-18.3821 843.781 8.38567 838.441 33.3295 833.805C48.5709 830.972 64.8044 828.639 80.0702 830.226C89.7888 831.236 99.1199 833.841 107.552 838.938C115.102 843.499 121.381 849.776 127.896 855.687C141.36 867.899 156.066 878.748 170.699 889.645C179.878 896.477 189.136 903.399 199.546 908.165C205.938 911.091 212.684 913.165 219.012 916.204C228.451 920.735 236.672 927.252 244.536 934.316C258.948 947.261 272.134 962.009 289.617 969.575C298.23 973.302 307.46 975.1 316.841 976.388C335.796 978.987 355.371 979.505 371.536 989.729C388.351 1000.37 397.776 1019.49 403.552 1038.19"
        stroke="url(#paint35_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M-44.6318 864.221C-24.7807 871.912 -2.07683 867.621 19.1662 863.977C32.1534 861.751 45.934 859.958 58.9354 861.313C67.1993 862.173 75.1589 864.32 82.4022 868.469C88.8826 872.184 94.3506 877.281 100.001 882.099C111.69 892.056 124.357 900.981 136.91 910.036C144.8 915.719 152.731 921.512 161.551 925.624C166.966 928.148 172.654 930.011 177.994 932.663C185.955 936.617 192.91 942.201 199.541 948.273C211.682 959.388 222.671 972.061 237.127 978.969C244.247 982.374 251.869 984.232 259.642 985.663C275.342 988.548 291.665 989.68 305.348 998.467C319.583 1007.61 328.003 1023.42 333.567 1038.74"
        stroke="url(#paint36_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M-47.6533 894.52C-31.1763 900.041 -12.5384 896.796 5.00377 894.147C15.7369 892.53 27.0644 891.276 37.8016 892.398C44.6107 893.11 51.1987 894.794 57.251 898C62.6642 900.869 67.3186 904.786 72.1069 908.512C82.0183 916.213 92.6459 923.215 103.121 930.426C109.721 934.961 116.326 939.623 123.557 943.083C127.996 945.207 132.626 946.856 136.978 949.123C143.463 952.499 149.152 957.151 154.549 962.232C164.42 971.514 173.213 982.111 184.638 988.365C190.266 991.449 196.28 993.366 202.444 994.938C214.892 998.105 227.96 999.856 239.16 1007.21C250.816 1014.86 258.232 1027.36 263.578 1039.31"
        stroke="url(#paint37_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M-50.6768 924.813C-37.5718 928.163 -23 925.966 -9.16057 924.308C-0.681631 923.298 8.19295 922.586 16.6658 923.474C22.0202 924.036 27.2386 925.262 32.0979 927.52C36.4439 929.543 40.2867 932.28 44.2087 934.914C52.3447 940.359 60.9312 945.438 69.327 950.808C74.6387 954.193 79.916 957.725 85.5565 960.533C89.0219 962.258 92.5928 963.694 95.9548 965.575C100.962 968.375 105.385 972.096 109.549 976.182C117.147 983.634 123.745 992.154 132.141 997.752C136.278 1000.51 140.683 1002.49 145.236 1004.21C154.429 1007.66 164.243 1010.02 172.963 1015.94C182.039 1022.1 188.45 1031.29 193.581 1039.86"
        stroke="url(#paint38_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M-53.7012 955.11C-43.9704 956.289 -33.4625 955.139 -23.3259 954.475C-17.1011 954.072 -10.6815 953.899 -4.47096 954.556C-0.571331 954.968 3.27554 955.733 6.9459 957.048C10.2247 958.223 13.2539 959.783 16.3135 961.323C22.6742 964.514 29.2196 967.669 35.5377 971.196C39.5591 973.432 43.5094 975.834 47.5612 977.989C50.0507 979.314 52.5646 980.537 54.9364 982.03C58.4668 984.252 61.6238 987.042 64.5536 990.136C69.8816 995.758 74.2824 1002.2 79.6489 1007.14C82.2947 1009.58 85.0885 1011.62 88.0345 1013.48C93.9753 1017.22 100.535 1020.2 106.774 1024.68C113.268 1029.34 118.676 1035.22 123.592 1040.41"
        stroke="url(#paint39_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M-56.7246 985.41C-46.446 983.806 -35.9503 984.528 -25.6067 985.644C-8.99581 987.435 9.06785 991.091 19.5534 1004.1C24.1206 1009.76 26.7866 1016.71 30.8303 1022.76C36.3165 1030.97 44.3856 1037.42 53.599 1040.98"
        stroke="url(#paint40_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M664.621 28.6598C656.862 39.8332 653.971 53.985 645.354 64.5091C634.613 77.6262 616.99 82.8122 603.96 93.6589C601.389 95.7995 598.94 98.2443 597.634 101.322C594.42 108.888 599.135 117.694 605.488 122.91C620.755 135.449 644.685 135.246 657.284 150.463C662.726 157.033 665.175 165.599 670.14 172.536C687.045 196.147 723.363 191.785 749.041 205.344C762.769 212.593 773.427 225.451 778.008 240.284C785.3 263.897 779.163 294.098 798.217 309.834C803.52 314.215 810.141 316.692 816.796 318.433C838.536 324.122 862.11 322.552 882.905 314.03C896.154 308.601 908.122 300.528 920.103 292.686C943.339 277.477 967.867 262.609 995.328 258.466C1031.94 252.943 1071.56 266.819 1105.28 251.521C1136.58 237.322 1153.19 197.139 1141.05 164.986C1132.78 143.078 1113.63 126.179 1107.47 103.584C1101.44 81.4488 1109.03 57.8238 1119.72 37.5242C1130.41 17.2226 1144.29 -1.51665 1152.26 -23.0315C1153.63 -26.7465 1154.82 -30.9302 1153.27 -34.5803C1152.34 -36.7776 1150.54 -38.4697 1148.75 -40.0584C1107.43 -76.9506 1052.45 -96.7734 997.171 -100.365C941.894 -103.958 886.34 -92.0439 834.943 -71.3873C816.483 -63.9695 799.085 -55.1618 785.964 -39.9001C775.357 -27.5642 765.443 -18.4157 750.07 -11.9555C721.786 -0.0720444 683.634 1.27923 664.621 28.6598Z"
        stroke="url(#paint41_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M852.336 -43.0916C837.853 -37.2705 824.109 -30.435 813.54 -18.7686C805.053 -9.35433 797.069 -2.33623 784.987 2.6712C762.634 11.9171 732.855 13.2826 717.512 34.2598C711.219 42.8321 708.591 53.6585 701.693 61.7864C693.07 71.9311 679.324 76.1655 669.082 84.7013C667.061 86.3853 665.125 88.2966 664.066 90.6927C661.514 96.4712 664.959 103.209 669.617 107.251C680.813 116.97 698.55 117.174 707.857 128.965C711.874 134.055 713.662 140.645 717.35 146.014C729.905 164.291 757.178 161.606 776.691 172.305C787.742 178.434 796.779 188.2 801.263 199.198C803.503 204.711 804.745 210.654 805.861 216.57C808.259 229.456 810.27 242.265 821.112 250.354C825.537 253.641 830.94 255.566 836.356 257.042C853.563 261.668 871.856 261.211 887.994 255.638C898.265 252.067 907.547 246.548 916.862 241.181C928.758 234.336 941.114 227.563 954.389 222.953C961.286 220.561 968.428 218.735 975.847 217.792C1004.79 214.113 1036.24 224 1062.57 211.392C1086.69 199.842 1099.48 168.714 1090.76 143.587C1084.83 126.463 1070.49 113.182 1066.63 95.6231C1062.77 78.022 1069.88 59.6134 1078.74 43.6903C1087.71 27.6779 1098.53 12.7023 1104.15 -5.05094C1105.09 -8.03957 1105.93 -11.3711 1104.68 -14.3212C1103.93 -16.0864 1102.53 -17.4742 1101.13 -18.7889C1069.72 -48.2491 1027.53 -64.7383 984.357 -67.6519C983.314 -67.7229 982.269 -67.7878 981.224 -67.8446C937.287 -70.2124 893.158 -59.5037 852.336 -43.0916Z"
        stroke="url(#paint42_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M869.728 -14.7955C859.222 -10.5712 849.106 -5.73221 841.118 2.36326C834.731 8.83558 828.697 13.7456 819.906 17.2983C803.477 23.9086 782.106 25.3126 770.401 39.8621C765.587 45.8475 763.209 53.3343 758.029 59.0661C751.522 66.2384 741.653 69.5232 734.201 75.748C732.73 76.9755 731.308 78.3532 730.496 80.0676C728.607 84.0586 730.78 88.7272 733.745 91.5961C740.868 98.4945 752.415 99.1072 758.427 107.468C761.022 111.078 762.148 115.694 764.558 119.496C772.763 132.441 790.991 131.432 804.337 139.272C812.713 144.282 820.129 150.953 824.515 158.117C826.7 161.708 828.232 165.502 829.61 169.258C832.609 177.428 835.362 185.504 844.003 190.876C847.542 193.078 851.732 194.459 855.911 195.652C868.572 199.266 881.604 199.907 893.079 197.247C900.375 195.557 906.965 192.572 913.618 189.679C922.117 185.999 930.976 182.314 940.648 179.849C945.674 178.571 950.914 177.591 956.364 177.12C977.635 175.288 1000.93 181.196 1019.85 171.266C1036.8 162.378 1045.78 140.291 1040.48 122.193C1036.87 109.85 1027.4 100.14 1025.8 87.664C1024.11 74.5367 1030.68 61.3791 1037.75 49.8608C1044.96 38.1112 1052.8 26.9581 1056.04 12.932C1056.56 10.6779 1057.05 8.19241 1056.09 5.93826C1055.53 4.60727 1054.52 3.51773 1053.51 2.48094C1031.11 -20.509 1000.01 -33.6545 967.608 -35.2208C966.833 -35.2594 966.058 -35.2939 965.283 -35.3203C932.682 -36.4666 899.976 -26.961 869.728 -14.7955Z"
        stroke="url(#paint43_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M887.124 13.5004C880.595 16.1299 874.129 18.9846 868.698 23.495C864.429 27.0395 860.326 29.8253 854.826 31.9252C844.324 35.8999 831.331 37.3283 823.292 45.4643C819.942 48.8527 817.828 53.01 814.367 56.3455C809.976 60.5434 803.984 62.8808 799.322 66.7926C798.403 67.5636 797.496 68.4056 796.93 69.4383C795.717 71.6458 796.605 74.2428 797.875 75.937C800.927 80.0152 806.281 81.0357 809 85.9681C810.173 88.0985 810.635 90.7361 811.768 92.972C815.622 100.583 824.805 101.252 831.988 106.231C837.687 110.121 843.492 113.687 847.771 117.029C849.904 118.695 851.709 120.34 853.365 121.939C856.936 125.388 860.476 128.718 866.9 131.392C869.56 132.5 872.53 133.332 875.472 134.257C883.596 136.811 891.341 138.574 898.17 138.85C902.479 139.025 906.391 138.589 910.378 138.171C915.481 137.653 920.843 137.059 926.908 136.738C930.065 136.576 933.401 136.44 936.882 136.442C950.482 136.454 965.616 138.428 977.142 131.134C986.916 124.95 992.075 111.861 990.199 100.792C988.925 93.2337 984.465 86.9866 984.964 79.7007C985.567 70.9154 991.532 63.1608 996.772 56.025C1002.26 48.5565 1007.15 41.2685 1007.93 30.9087C1008.04 29.3972 1008.16 27.7476 1007.51 26.1914C1007.13 25.2926 1006.52 24.5074 1005.89 23.7445C992.437 7.30808 972.494 -2.52417 950.858 -2.79604C950.352 -2.80213 949.847 -2.80619 949.342 -2.80416C928.079 -2.72097 906.795 5.57943 887.124 13.5004Z"
        stroke="url(#paint44_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M863.361 58.8059C859.52 62.4539 857.339 68.4149 859.634 73.189C864.15 77.326 871.244 76.3663 877.113 74.6154C882.983 72.8644 889.338 70.5859 895.027 72.8583C903.686 76.3197 905.673 88.0713 913.166 93.6245C919.496 98.3154 929.43 97.0879 934.427 90.997C939.014 85.4073 939.339 77.1515 944.125 71.7302C952.846 61.8533 965.973 61.2791 958.271 45.003C953.635 35.2052 944.971 28.4955 934.102 29.6236C923.943 30.6787 913.831 38.0275 904.52 41.7912C891.874 46.9041 873.514 49.1643 863.361 58.8059Z"
        stroke="url(#paint45_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1527.31 171.612C1506.18 162.023 1484.39 153.883 1462.14 147.267C1450.37 143.765 1433.83 142.911 1429.71 154.478C1428.19 158.714 1429.06 163.435 1428.13 167.834C1425.68 179.367 1412.3 184.717 1400.6 186.168C1397.78 186.519 1394.82 186.799 1392.44 188.363C1388.31 191.09 1387.35 196.655 1386.9 201.59C1385.23 219.809 1385.08 239.153 1375.42 254.691C1360.81 278.184 1329.77 284.878 1302.12 285.571C1272.33 286.32 1242.42 282.621 1213.71 274.637C1193.14 268.916 1171.82 260.932 1151.02 265.775C1139.91 268.362 1129.95 274.455 1119.13 278.056C1102.04 283.741 1083.6 283.005 1065.63 284.113C1011.57 287.444 958.744 308.515 917.234 343.309C903.392 354.91 890.49 368.431 883.687 385.162C875.612 405.021 876.943 427.709 883.115 448.24C889.289 468.769 899.994 487.593 910.613 506.217C918.114 519.372 928.535 534.281 943.675 533.93C949.642 533.792 955.715 531.154 961.404 532.954C969.946 535.659 972.528 546.268 978.266 553.146C987.565 564.291 1005.21 564.608 1018.38 558.513C1031.55 552.418 1041.68 541.437 1052.62 531.903C1110.85 481.171 1193.52 470.718 1270.74 470.085C1290.07 469.927 1309.72 470.292 1328.14 476.146C1339.39 479.723 1349.95 485.286 1361.27 488.644C1380.78 494.429 1401.54 493.414 1421.87 494.278C1466.76 496.188 1511.23 507.641 1551.46 527.655"
        stroke="url(#paint46_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1520.75 201.299C1511.03 192.909 1500.85 184.272 1488.44 180.942C1476.03 177.613 1460.74 181.297 1454.77 192.667C1453.55 194.984 1452.69 197.612 1450.72 199.332C1447.76 201.911 1443.39 201.621 1439.47 201.867C1426.05 202.707 1413.6 212.334 1409.41 225.112C1404.14 241.169 1411 260.337 1402.19 274.756C1396.76 283.653 1386.61 288.395 1376.83 292.021C1342.17 304.874 1304.63 309.902 1267.81 306.619C1232.9 303.506 1197.81 293.067 1163.36 299.536C1150.75 301.904 1138.66 306.491 1126.15 309.325C1110.57 312.856 1094.51 313.637 1078.69 315.865C1049.27 320.008 1020.58 329.225 994.246 342.988C970.335 355.486 947.71 372.476 934.829 396.182C921.947 419.888 920.756 451.274 937.209 472.657C939.871 476.119 943.137 479.391 947.323 480.629C952.967 482.297 959.095 479.953 964.889 480.988C978.702 483.453 984.201 503.063 998.02 505.492C1004.35 506.603 1010.61 503.676 1016.34 500.766C1058.12 479.535 1099.02 454.62 1144.9 445.07C1167.12 440.442 1189.94 439.569 1212.62 438.709C1252.39 437.203 1292.85 435.771 1331.31 445.981C1344.31 449.43 1356.95 454.182 1370.1 456.965C1397.81 462.829 1426.59 459.735 1454.78 462.452C1480.82 464.961 1506.37 472.497 1529.6 484.52"
        stroke="url(#paint47_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1018.16 378.13C1010.08 382.511 1001.89 387.455 996.835 395.123C991.781 402.79 990.831 413.919 997.03 420.693C1000.35 424.323 1005.4 426.48 1007.51 430.927C1009.18 434.46 1008.59 438.682 1009.93 442.354C1012.05 448.194 1018.73 451.355 1024.94 451.3C1031.15 451.245 1037.03 448.654 1042.68 446.063C1076.8 430.412 1110.88 412.845 1148.04 407.509C1180.12 402.904 1213.05 407.674 1245.03 402.441C1256.75 400.524 1270.2 395.368 1272.88 383.799C1280.15 352.407 1232.19 329.474 1207.17 330.933C1167.12 333.268 1126.7 337.501 1088.16 349.058C1063.92 356.327 1040.4 366.058 1018.16 378.13Z"
        stroke="url(#paint48_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1530.36 235.018C1521.37 236.302 1512.94 231.037 1504.88 226.857C1496.81 222.678 1486.6 219.537 1479.06 224.593C1474.18 227.862 1471.73 233.818 1467.1 237.432C1463.36 240.35 1458.41 241.569 1455.07 244.931C1450.6 249.431 1450.19 256.397 1449.1 262.646C1446.48 277.684 1438.28 291.684 1426.45 301.325C1413.81 311.62 1397.85 316.686 1382.38 321.836C1366.92 326.987 1351.05 332.739 1339.26 343.986C1327.46 355.232 1320.79 373.483 1327.63 388.278C1334.39 402.906 1351.45 409.515 1367.27 412.597C1394.92 417.985 1423.41 416.88 1451.36 420.39C1479.31 423.9 1508.2 433.01 1526.74 454.222"
        stroke="url(#paint49_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1526.6 287.292C1523.11 281.489 1515.72 278.55 1509.05 279.736C1502.38 280.923 1496.67 285.864 1493.89 292.036C1492.2 295.777 1491.51 299.896 1489.89 303.67C1484.02 317.394 1468.15 323.154 1454.36 328.867C1443.03 333.562 1432.07 339.158 1421.62 345.586C1413.44 350.624 1404.71 357.674 1404.6 367.287C1404.53 374.186 1409.26 380.467 1415.23 383.929C1421.2 387.39 1428.23 388.471 1435.11 388.956C1451.85 390.137 1468.83 388.185 1485.35 391.111C1501.72 394.01 1517.2 401.781 1529.32 413.176"
        stroke="url(#paint50_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1088.66 378.772C1086.18 379.894 1083.6 381.17 1082.1 383.44C1080.6 385.711 1080.7 389.267 1083.02 390.698C1084.72 391.745 1086.9 391.333 1088.84 390.884C1112.55 385.422 1136.43 379.545 1160.83 378.471C1168.52 378.132 1197.87 384.367 1190.37 372.772C1184.69 364.009 1162.2 361.72 1153.11 361.935C1131.41 362.451 1108.26 369.905 1088.66 378.772Z"
        stroke="url(#paint51_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M769.32 533.303C741.436 558.038 725.673 594.646 696.252 617.527C680.793 629.548 660.53 639.389 655.994 658.438C653.534 668.764 656.513 679.584 660.384 689.467C663.251 696.783 666.652 703.962 671.397 710.227C692.902 738.622 736.912 742.783 757.217 772.049C764.29 782.244 767.963 794.909 777.014 803.398C785.901 811.731 798.616 814.653 810.785 815.184C822.955 815.716 835.171 814.198 847.312 815.172C877.594 817.601 907.357 835.338 936.702 827.475C954.55 822.693 968.661 809.071 980.056 794.525C990.292 781.459 999.264 766.605 1001.08 750.108C1004.55 718.671 981.697 689.556 981.756 657.929C981.772 648.636 983.787 639.445 984.006 630.155C984.225 620.864 982.326 610.931 975.836 604.278C969.936 598.229 960.767 595.403 956.652 588.024C955.494 585.944 954.812 583.607 953.465 581.645C947.213 572.547 933.283 577.197 922.268 576.485C884.332 574.034 887.098 523.199 860.823 506.769C834.719 490.446 788.686 516.124 769.32 533.303Z"
        stroke="url(#paint52_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M786.731 576.639C779.989 582.867 774.422 590.054 769.083 597.506C759.478 610.936 750.427 625.051 737.495 635.354C726.942 643.746 713.117 650.664 709.763 663.719C707.949 670.787 709.759 678.189 712.166 684.964C713.947 689.981 716.088 694.907 719.129 699.225C732.871 718.851 762.479 721.894 775.391 742.742C778.808 748.257 781.91 754.374 785.877 759.128C787.951 761.625 790.209 763.831 792.881 765.632C795.397 767.331 798.181 768.572 801.127 769.487C807.112 771.332 813.838 771.823 820.452 772.082C829.179 772.448 837.915 771.577 846.593 772.413C861.721 773.874 876.658 780.466 891.506 782.458C897.897 783.315 904.272 783.317 910.618 781.718C923.451 778.49 933.785 769.153 942.199 759.002C949.854 749.829 956.332 739.42 957.785 727.896C960.652 705.722 944.508 685 943.414 662.84C943.096 656.38 944.136 650.001 943.944 643.579C943.745 637.152 942.124 630.316 937.447 625.696C933.16 621.476 926.7 619.431 923.628 614.383C922.764 612.961 922.224 611.364 921.23 610.029C916.569 603.766 906.705 606.669 898.777 606.012C871.943 603.784 872.048 569.401 852.84 558.189C836.58 548.783 810.938 559.486 794.648 570.481C791.613 572.536 788.906 574.628 786.731 576.639Z"
        stroke="url(#paint53_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M804.139 619.989C800.601 623.584 797.896 627.634 795.261 631.838C790.521 639.446 785.688 647.298 778.735 653.194C773.089 657.956 765.701 661.955 763.53 669.014C762.363 672.828 763.001 676.807 763.946 680.473C764.642 683.192 765.535 685.858 766.86 688.238C772.896 699.065 787.595 701.402 793.567 713.452C795.752 717.863 798.799 722.278 802.541 724.863C804.49 726.21 806.523 727.204 808.751 727.884C810.843 728.527 813.057 728.849 815.331 728.994C819.979 729.288 825.04 728.821 830.122 728.998C835.407 729.182 840.662 728.971 845.877 729.673C854.977 730.899 863.944 734.914 872.955 736.206C876.818 736.758 880.687 736.805 884.54 735.977C892.358 734.301 898.885 729.227 904.345 723.495C909.395 718.193 913.371 712.247 914.489 705.699C916.695 692.775 907.343 680.477 905.075 667.766C904.428 664.147 904.489 660.574 903.884 657.017C903.269 653.452 901.932 649.709 899.063 647.126C896.397 644.726 892.636 643.47 890.611 640.753C890.039 639.988 889.639 639.134 889.004 638.426C885.926 634.997 880.135 636.159 875.298 635.549C859.566 633.566 857.04 615.551 844.868 609.621C834.346 604.494 819.137 609.929 808.978 616.257C807.114 617.428 805.428 618.68 804.139 619.989Z"
        stroke="url(#paint54_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M823.297 662.027C822.611 662.309 821.899 662.674 821.546 663.327C821.087 664.171 821.367 665.2 821.434 666.157C821.931 673.19 810.957 677.142 811.736 684.15C812.127 687.678 815.672 690.188 819.198 690.588C822.725 690.986 826.216 689.766 829.528 688.49C832.839 687.214 836.233 685.838 839.782 685.905C844.854 686.001 849.407 689.016 854.396 689.945C858.489 690.708 862.841 690 866.481 687.979C879.507 680.748 865.136 669.726 856.762 666.817C847.119 663.467 833.131 657.973 823.297 662.027Z"
        stroke="url(#paint55_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1003.1 1033.44C981.599 998.649 964.01 961.446 950.771 922.754C947.093 912.003 943.767 900.093 947.953 889.528C954.685 872.532 976.387 868.019 990.121 855.953C1005.28 842.633 1010.27 820.248 1025.99 807.591C1038.17 797.786 1054.88 795.531 1070.47 796.745C1086.06 797.958 1101.27 802.227 1116.81 803.939C1141.52 806.662 1166.5 802.88 1191.32 804.181C1216.15 805.481 1242.57 813.153 1257.46 833.061C1264.88 842.984 1268.77 855.073 1275.11 865.721C1289.53 889.95 1316.35 905.305 1344.21 909.651C1372.07 913.999 1400.8 908.235 1426.85 897.463C1444.89 890.007 1462.09 880.128 1481.08 875.628C1500.07 871.13 1522.09 873.051 1536.07 886.669C1540.52 891.003 1550.35 895.491 1554.5 900.111C1573.76 921.547 1585.23 949.114 1591.14 977.324C1597.04 1005.53 1597.68 1034.56 1597.48 1063.39"
        stroke="url(#paint56_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1056.34 1030.72C1039.38 1003.92 1025.56 975.062 1015.31 945.007C1012.46 936.656 1009.91 927.428 1013.01 919.207C1017.99 905.98 1034.34 902.184 1044.66 892.583C1056.26 881.787 1060.37 864.085 1072.79 853.952C1082.42 846.098 1095.55 844.024 1107.9 844.73C1112.84 845.013 1117.75 845.69 1122.65 846.5C1129.99 847.711 1137.3 849.206 1144.69 850.05C1164.3 852.286 1184.09 849.902 1203.79 851.028C1223.32 852.13 1244.04 857.797 1256.11 872.557C1262.12 879.916 1265.49 888.878 1270.69 896.755C1278.92 909.224 1291.65 918.462 1306.01 923.991C1312.3 926.41 1318.91 928.122 1325.6 929.086C1347.55 932.259 1370.18 928.029 1390.65 920.327C1404.85 915.009 1418.3 907.814 1433 905.262C1447.9 902.675 1464.59 905.495 1475.03 917.009C1478.4 920.724 1485.7 924.632 1488.88 928.532C1503.21 946.064 1512.31 967.847 1517.23 990.195C1522.15 1012.55 1523.33 1035.43 1524.03 1058.01"
        stroke="url(#paint57_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1109.57 1027.99C1097.17 1009.18 1087.11 988.674 1079.85 967.256C1077.84 961.305 1076.04 954.76 1078.06 948.884C1081.3 939.429 1092.29 936.327 1099.2 929.21C1107.24 920.923 1110.47 907.92 1119.59 900.307C1126.66 894.407 1136.21 892.512 1145.32 892.709C1148.97 892.788 1152.6 893.17 1156.24 893.681C1161.69 894.448 1167.1 895.493 1172.57 896.154C1187.07 897.903 1201.67 896.917 1216.26 897.869C1230.49 898.769 1245.51 902.432 1254.75 912.047C1259.36 916.841 1262.2 922.676 1266.26 927.783C1272.69 935.867 1282.12 941.781 1292.64 945.293C1297.25 946.827 1302.09 947.908 1306.99 948.517C1323.02 950.516 1339.57 947.819 1354.45 943.189C1364.81 940.008 1374.55 935.526 1384.92 934.893C1395.77 934.231 1407.07 937.964 1413.98 947.344C1416.27 950.449 1421.05 953.752 1423.27 956.947C1432.68 970.505 1439.38 986.572 1443.32 1003.06C1447.26 1019.55 1448.97 1036.29 1450.58 1052.63"
        stroke="url(#paint58_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1162.81 1025.28C1154.95 1014.46 1148.67 1002.3 1144.4 989.513C1143.21 985.962 1142.18 982.101 1143.12 978.566C1144.61 972.883 1150.22 970.428 1153.74 965.843C1158.21 960.016 1160.58 951.762 1166.4 946.672C1170.91 942.723 1176.88 941.009 1182.75 940.698C1185.1 940.575 1187.46 940.658 1189.84 940.873C1193.39 941.195 1196.91 941.792 1200.46 942.269C1209.86 943.533 1219.26 943.943 1228.73 944.718C1237.67 945.418 1246.98 947.075 1253.41 951.545C1256.61 953.775 1258.92 956.483 1261.85 958.819C1266.47 962.518 1272.6 965.108 1279.27 966.6C1282.21 967.249 1285.28 967.701 1288.38 967.951C1298.51 968.777 1308.96 967.576 1318.26 966.052C1324.78 964.985 1330.9 963.362 1336.84 964.526C1343.77 965.882 1349.52 970.493 1352.94 977.682C1354.13 980.194 1356.43 982.848 1357.66 985.367C1362.29 994.808 1366.47 1005.3 1369.42 1015.93C1372.38 1026.56 1374.61 1037.15 1377.14 1047.25"
        stroke="url(#paint59_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <path
        d="M1216.04 1022.56C1210.34 1017.67 1206.98 1009.87 1208.28 1002.47C1209.57 995.071 1215.94 988.603 1223.43 988.053C1229.48 987.609 1235.19 990.731 1241.2 991.557C1249.49 992.697 1257.67 989.435 1265.9 987.901C1274.13 986.367 1284.03 987.25 1288.76 994.154C1292.57 999.707 1291.65 1007.06 1292.04 1013.78C1292.65 1024.09 1296.82 1034.15 1303.69 1041.86"
        stroke="url(#paint60_linear_19456_24304)"
        stroke-opacity="0.3"
        stroke-miterlimit="10"
      />
      <defs>
        <linearGradient
          id="paint0_linear_19456_24304"
          x1="379.448"
          y1="-31.5547"
          x2="379.448"
          y2="928.836"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_19456_24304"
          x1="1289.33"
          y1="502.172"
          x2="1289.33"
          y2="870.73"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_19456_24304"
          x1="1352.07"
          y1="-34.3281"
          x2="1352.07"
          y2="258.083"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_19456_24304"
          x1="1311.11"
          y1="552.109"
          x2="1311.11"
          y2="830.861"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_19456_24304"
          x1="1405.84"
          y1="651.75"
          x2="1405.84"
          y2="716.322"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_19456_24304"
          x1="1402.61"
          y1="612.711"
          x2="1402.61"
          y2="756.017"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_19456_24304"
          x1="1368.43"
          y1="580.281"
          x2="1368.43"
          y2="790.941"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_19456_24304"
          x1="1362.36"
          y1="-21.8711"
          x2="1362.36"
          y2="218.354"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_19456_24304"
          x1="1291.34"
          y1="-29.5938"
          x2="1291.34"
          y2="135.234"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_19456_24304"
          x1="1466.45"
          y1="-22.5977"
          x2="1466.45"
          y2="58.2662"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_19456_24304"
          x1="1492.37"
          y1="-25.4453"
          x2="1492.37"
          y2="16.796"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_19456_24304"
          x1="1303.55"
          y1="-33.2227"
          x2="1303.55"
          y2="56.8839"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_19456_24304"
          x1="295.81"
          y1="-31.6992"
          x2="295.81"
          y2="280.19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_19456_24304"
          x1="254.23"
          y1="-34.3125"
          x2="254.23"
          y2="246.572"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_19456_24304"
          x1="212.646"
          y1="-36.9258"
          x2="212.646"
          y2="212.98"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_19456_24304"
          x1="171.063"
          y1="-39.543"
          x2="171.063"
          y2="179.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_19456_24304"
          x1="129.478"
          y1="-42.1523"
          x2="129.478"
          y2="145.978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_19456_24304"
          x1="87.8938"
          y1="-44.7617"
          x2="87.8938"
          y2="112.787"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_19456_24304"
          x1="46.312"
          y1="-47.375"
          x2="46.312"
          y2="80.9098"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_19456_24304"
          x1="99.7794"
          y1="266.695"
          x2="99.7794"
          y2="673.258"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_19456_24304"
          x1="97.651"
          y1="314.875"
          x2="97.651"
          y2="634.329"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_19456_24304"
          x1="95.4136"
          y1="362.984"
          x2="95.4136"
          y2="597.869"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_19456_24304"
          x1="92.9363"
          y1="410.844"
          x2="92.9363"
          y2="562.394"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_19456_24304"
          x1="89.9708"
          y1="450.312"
          x2="89.9708"
          y2="527.772"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_19456_24304"
          x1="558.403"
          y1="194.047"
          x2="558.403"
          y2="599.731"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_19456_24304"
          x1="555.076"
          y1="249.879"
          x2="555.076"
          y2="549.979"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_19456_24304"
          x1="552.016"
          y1="305.445"
          x2="552.016"
          y2="500.93"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_19456_24304"
          x1="557.853"
          y1="359.195"
          x2="557.853"
          y2="454.734"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_19456_24304"
          x1="452.584"
          y1="596.898"
          x2="452.584"
          y2="860.196"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_19456_24304"
          x1="442.988"
          y1="647.242"
          x2="442.988"
          y2="806.108"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_19456_24304"
          x1="433.306"
          y1="694.945"
          x2="433.306"
          y2="752.049"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_19456_24304"
          x1="473.529"
          y1="745.453"
          x2="473.529"
          y2="1073.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_19456_24304"
          x1="728.583"
          y1="908.57"
          x2="728.583"
          y2="1026.88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_19456_24304"
          x1="740.603"
          y1="951.594"
          x2="740.603"
          y2="1026.98"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_19456_24304"
          x1="217.48"
          y1="798.586"
          x2="217.48"
          y2="1037.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_19456_24304"
          x1="180.972"
          y1="829.711"
          x2="180.972"
          y2="1038.19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint36_linear_19456_24304"
          x1="144.467"
          y1="860.844"
          x2="144.467"
          y2="1038.74"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint37_linear_19456_24304"
          x1="107.962"
          y1="891.969"
          x2="107.962"
          y2="1039.31"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint38_linear_19456_24304"
          x1="71.4523"
          y1="923.07"
          x2="71.4523"
          y2="1039.86"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_19456_24304"
          x1="34.9453"
          y1="954.117"
          x2="34.9453"
          y2="1040.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_19456_24304"
          x1="-1.56278"
          y1="984.477"
          x2="-1.56278"
          y2="1040.98"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_19456_24304"
          x1="875.298"
          y1="-101"
          x2="875.298"
          y2="321.796"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_19456_24304"
          x1="884.254"
          y1="-68.1719"
          x2="884.254"
          y2="260.196"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_19456_24304"
          x1="893.212"
          y1="-35.4141"
          x2="893.212"
          y2="198.877"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_19456_24304"
          x1="902.186"
          y1="-2.80469"
          x2="902.186"
          y2="138.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_19456_24304"
          x1="909.649"
          y1="29.5"
          x2="909.649"
          y2="96.4824"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint46_linear_19456_24304"
          x1="1214.76"
          y1="144.957"
          x2="1214.76"
          y2="562.473"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint47_linear_19456_24304"
          x1="1227.31"
          y1="179.766"
          x2="1227.31"
          y2="505.733"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint48_linear_19456_24304"
          x1="1133.16"
          y1="330.867"
          x2="1133.16"
          y2="451.301"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_19456_24304"
          x1="1427.62"
          y1="221.984"
          x2="1427.62"
          y2="454.222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint50_linear_19456_24304"
          x1="1466.96"
          y1="279.477"
          x2="1466.96"
          y2="413.176"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint51_linear_19456_24304"
          x1="1136.34"
          y1="361.922"
          x2="1136.34"
          y2="391.355"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint52_linear_19456_24304"
          x1="828.27"
          y1="501.555"
          x2="828.27"
          y2="829.471"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint53_linear_19456_24304"
          x1="833.576"
          y1="554.578"
          x2="833.576"
          y2="783.03"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint54_linear_19456_24304"
          x1="838.861"
          y1="607.586"
          x2="838.861"
          y2="736.611"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint55_linear_19456_24304"
          x1="841.706"
          y1="660.594"
          x2="841.706"
          y2="690.664"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint56_linear_19456_24304"
          x1="1271.76"
          y1="796.445"
          x2="1271.76"
          y2="1063.39"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint57_linear_19456_24304"
          x1="1267.81"
          y1="844.602"
          x2="1267.81"
          y2="1058.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint58_linear_19456_24304"
          x1="1263.88"
          y1="892.695"
          x2="1263.88"
          y2="1052.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint59_linear_19456_24304"
          x1="1259.95"
          y1="940.641"
          x2="1259.95"
          y2="1047.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
        <linearGradient
          id="paint60_linear_19456_24304"
          x1="1255.84"
          y1="987.258"
          x2="1255.84"
          y2="1041.86"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#999999" />
          <stop offset="1" stop-color="#4A4A4A" />
        </linearGradient>
      </defs>
    </svg>
  );
};
